import {
    Button,
    Flex,
    Grid,
    Heading,
    Stack,
    Text
} from '@chakra-ui/react'
import { useState } from 'react'

import { Loading } from '@/components/Loading'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import {
    OffersVehicleProvider
} from '@/context/OffersVehicleProvider'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { useInvokeBmw } from '@/hooks/useOffer'
import { LeasingPageComponent } from './leasing'

function LeasingPageWrapper() {
    const { isLoadingData, insuranceParams, insuranceParamsId, isContracted } = useInsuranceParams()

    const [isGoingBack, setIsGoingBack] = useState(false)
    const { mutateAsync: invokeBmw } = useInvokeBmw()

    return (
        <>
            {isLoadingData && <Loading large={true} />}
            {!isLoadingData && (
                <WizzardHeaderProvider>
                    <OffersVehicleProvider>
                        {isContracted && (
                            <Section>
                                <Container>
                                    <Grid
                                        sx={{
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Heading
                                            sx={{ fontSize: '2xl', fontWeight: 'medium' }}
                                            as="h2"
                                        >
                                            <Stack alignItems="center">
                                                <Flex>
                                                    Smlouva č.{' '}
                                                    <Text mx={2} fontWeight="bold">
                                                        {insuranceParams?.generalParams.contractNumber}
                                                    </Text>{' '}
                                                    byla již uzavřena.
                                                </Flex>

                                                <Flex>
                                                    <Button
                                                        colorScheme="red"
                                                        type="submit"
                                                        isLoading={isGoingBack}
                                                        onClick={() => {
                                                            setIsGoingBack(true)
                                                            invokeBmw({
                                                                action: 'Cancel',
                                                                paramsId: insuranceParamsId!,
                                                            }).catch(() => {
                                                                alert('Při zpracování požadavku došlo k chybě')
                                                                setIsGoingBack(false)
                                                            })
                                                        }}
                                                    >
                                                        Zpět
                                                    </Button>
                                                </Flex>
                                            </Stack>
                                        </Heading>
                                    </Grid>
                                </Container>
                            </Section>
                        )}
                        {!isContracted && <LeasingPageComponent />}
                    </OffersVehicleProvider>
                </WizzardHeaderProvider>
            )}
        </>
    )
}

export const LeasingPage = LeasingPageWrapper
